const files = require.context(".", true, /ListMobileCard$/);

const modules = {};

files.keys().forEach((key) => {
  if (key === "./writeIndex.js") return;
  if (key === "./listIndex.js") return;
  if (key === "./listMobileCardIndex.js") return;
  modules[
    key
      .toLowerCase()
      .replace(/(\.\/|\.js)/g, "")
      .replace("/", "_")
  ] = files(key).default;
});

export default modules;
